import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from '@nuxtjs/composition-api'
import { useMenuModel } from '@entities/menu'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuCategories',
  setup(__props) {

const menuModel = useMenuModel()

const activeElement = ref<string>('')

onMounted(() => {
  activeElement.value = menuModel.menuUser[0].name.replace(/\s/g, '')
})


return { __sfc: true,menuModel, activeElement }
}

})